export const SITE_ORIGIN = 'https://oidotipi.com'

export const ROUTES = {
    home: '/',
    invest: '/invest',
    asesoria: '/asesoria',
    schedule: '/schedule',
    faqs: '/preguntas-frecuentes',
    press: '/prensa',
    learn: '/aprender',
    learnArticle: '/aprender/:slug',
    learnEscandallos: '/aprender/escandallos',
    learnBeneficio: '/aprender/beneficio',
    learnInventario: '/aprender/inventario',
    learnEmprenderEnHosteleria: '/aprender/emprender-en-hosteleria',
    news: '/actualidad-hostelera',
    newsArticle: '/actualidad-hostelera/:slug',
    authors: '/autores',
    author: '/autores/:slug',
    cookiePolicy: '/cookie-policy',
    privacyPolicy: '/privacy-policy',
    termsAndConditions: '/terms-and-conditions',
    dataProcessingAgreement: '/data-processing-agreement',
    newsletterConfirm: '/newsletter/confirmar',
    /** Alternate accompaniment-paths landing. CSR + noindex. */
    ponloEnOrden: '/ponlo-en-orden',
    /** Quiz router for paid traffic. CSR + noindex; `/` stays the indexable SEO landing. */
    empieza: '/empieza',
} as const

export const NOINDEX_ROUTES = [
    ROUTES.invest,
    ROUTES.ponloEnOrden,
    ROUTES.empieza,
    ROUTES.asesoria,
    ROUTES.schedule,
    ROUTES.cookiePolicy,
    ROUTES.privacyPolicy,
    ROUTES.termsAndConditions,
    ROUTES.dataProcessingAgreement,
    ROUTES.newsletterConfirm,
] as const
